<template>
  <div>
  <StatisticsItem
    class="statistics-processes"
    :title="$t('dashboard.candidates-in-process')"
    :steps="formattedSteps"
    :is-loading="isLoading"
  />
</div>
</template>

<script setup lang="ts">
import { useStatisticsStore } from '@/store/pinia/statistics';
import { computed } from 'vue';

import StatisticsItem from './StatisticsItem.vue';
import { useStore } from '@/store';

const statisticsStore = useStatisticsStore();

const store = useStore();
const categoriesIcons: Record<number, string> = {
  0: 'check',
  1: 'arrow-dot-down',
  2: 'partners',
};

const isLoading = computed(() => statisticsStore?.processes?.isLoading || false);
const processes = computed(() => statisticsStore?.processes?.kpis || []);
const configurationProcess = computed(() => store.state.user?.profile?._organization?.configuration?.process);

const formattedSteps = computed(() => {
  return processes.value?.map((process) => {
    return {
      ...process,
      name: process.stepName,
      icon: getCategoryIcon(process.categoryKey),
      isLoading: isLoading.value,
    };
  }) || [];
});

const getCategoryIcon = (categoryKey: string) => {
  const categoryIndex = configurationProcess.value?.categories?.findIndex(
    (category) => category.key === categoryKey
  );
  return categoriesIcons[categoryIndex] || '';
};
</script>
